import { render, staticRenderFns } from "./PaymentElement.vue?vue&type=template&id=77983560&scoped=true"
import script from "./PaymentElement.vue?vue&type=script&lang=ts"
export * from "./PaymentElement.vue?vue&type=script&lang=ts"
import style0 from "./PaymentElement.vue?vue&type=style&index=0&id=77983560&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77983560",
  null
  
)

export default component.exports